/**
 * @generated SignedSource<<039a3c5725c4b4cda8e45f6b1d5fc544>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutHelpers_buyer$data = {
  readonly addressBook: {
    readonly addressList: ReadonlyArray<{
      readonly displayState: string | null;
      readonly serviceId: string | null;
      readonly state: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "checkoutHelpers_buyer";
};
export type checkoutHelpers_buyer$key = {
  readonly " $data"?: checkoutHelpers_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutHelpers_buyer">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutHelpers_buyer"
};

(node as any).hash = "3814acff8caaa2bfd5ba260314f946f2";

export default node;
